import Ajax from "../utils/ajax";
import moment from "moment"

export default {
  namespaced: true,

  state: {
    response: {
      solicitudes: [],
      cantidadTotal: 0,
    },

    request: {
      criterio: "",
      desde:  moment(new Date()).add(-20, 'day').format(),
      hasta: new Date(),
      skip: 1,
      cantidad: 10,
      estato:"",
      vacante:""
    },
  },
  mutations: {
    SET_SKIP(state, payload) {
      state.request.skip = payload;
    },

    SET_FILTER(state, payload) {
      state.request.criterio = payload;
    },
    SET_FECHA_DESDE(state, payload) {
      state.request.desde = payload;
    },
    SET_FECHA_HASTA(state, payload) {
      state.request.hasta = payload;
    },
    SET_ESTADO(state, payload){
      state.request.estatus = payload;
    },
    SET_VACANTE(state, payload){
      state.request.vacante = payload;
    },

    SET_RESPONSE(state, payload) {
      state.response.solicitudes = payload.solicitudes;
      state.response.cantidadTotal = payload.cantidad;
    },
  },
  actions: {
    async getListRequests({ commit }, { data }) {
      const resp = await Ajax.get("/api/v1/Application", { params: data });
      commit("SET_RESPONSE", resp.data);
    },
    async getRequest({ commit }, { id }) {
      try {
        const resp = await Ajax.get(`/api/v1/Application/${id}`);
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async checkApplication ({commit}, {data}){  
      try {
        const resp = await Ajax.put("/api/v1/Application/check", data)
        return Promise.resolve(resp.data);
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },

    async createApplication({commit}, {data}){
      try {
        const resp = await Ajax.post("/api/v1/Application", data)
        return Promise.resolve(resp.data)
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },
    async updateApplication({commit}, {data}){
      try {
        const resp = await Ajax.put("/api/v1/Application", data)
        return Promise.resolve(resp.data)
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },
    async getApplicationCurrentUser({commit}, {data}){
      try {
        const resp = await Ajax.get("/api/v1/Application/user")
        return Promise.resolve(resp.data)
      } catch (e) {
        return Promise.reject(e.response.data);
      }
    },
  },
};
